import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@layout/service/app.translation.service'

@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(key: string): string {
    const translation = this.translationService.getTranslation(key);
    return translation !== null && translation !== undefined ? translation : key; // Retourne la clé brute si non trouvée
  }
}